// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-operational-security-training.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-operational-security-training',
  title:
    'Train employees in operational security: document handling, physical access and off-site security',
  description:
    'Employees must be trained in: secure document handling and disposal procedures; responding to known threats such as social engineering; controlling physical access to facilities including checking the identity of visitors; and applying security practices when handling information outside organisational premises (remote work, travel, phone/voice services).',
  category: 'people',
  scfIds: ['SCF-PPL-003', 'SCF-PHY-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Operational security training content is documented',
    },
    { type: 'document-within-sla', description: 'Training content is current' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
